import { Box } from '@modusign/design-system';
import { SignatureType } from '@modusign/react-signing/types';

import SignatureFieldMarkerIcon from '@app/components/SignatureFieldMarkerIcon';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import { useSignatureFieldMarkerIcon } from '@app/features/apply-react-signing/libs/hooks/useSignatureFieldMarkerIcon';
import createFieldClassNameByParticipantOrder from '@app/libs/participantFields/createFieldClassNameByParticipantOrder';
import orderRotationForColor from '@app/libs/participantFields/orderRotationForColor';

import './SignatureFieldPlaceholder.scss';

interface SignatureFieldPlaceholderProps {
  allow: SignatureType[];
  size: AbsoluteSize;
  participantOrder: number;
  uploadOnly: boolean;
}

export function SignatureFieldPlaceholder({
  allow,
  size,
  participantOrder,
  uploadOnly,
}: SignatureFieldPlaceholderProps) {
  const placeholderByOrder = createFieldClassNameByParticipantOrder(
    'SignatureFieldPlaceholder',
    participantOrder
  );

  const { iconSize, markerIconType } = useSignatureFieldMarkerIcon(allow, size, uploadOnly);

  const colorByOrder = `participantOrder${orderRotationForColor(participantOrder)}`;
  return (
    <Box
      className={placeholderByOrder}
      display="flex"
      height={`${size.height}px`}
      position="absolute"
      width={`${size.width}px`}
    >
      <Box margin="auto">
        <SignatureFieldMarkerIcon color={colorByOrder} size={iconSize} type={markerIconType} />
      </Box>
    </Box>
  );
}
